import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Security page components
import { useAuth0 } from "@auth0/auth0-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { updateQuery } from "api/Auth0Wrapper";

function ChangePassword() {
  const { user } = useAuth0();
  const [changePasswordClicked, setChangePasswordClicked] = useState(false);

  const requestChangePass = async () => {
    setChangePasswordClicked(true);

    let data = JSON.stringify({
      query: `mutation GenerateChangePass($tenantId: String!, $input: ResetPassInput) {
        generateChangePass(tenantId: $tenantId, input: $input) {
          isSuccessful
          message
          resultObject
        }
      }`,
      variables: {
        tenantId: user?.stripeId,
        input: {
          email: user?.email
        }
      }
    });
    try {
      const response = await updateQuery(data);

      if (
        response?.generateChangePass?.isSuccessful &&
        response?.generateChangePass?.resultObject
      ) {
        // Request was successful (status 200-299)
        toast.success(response.generateChangePass.message, 2500);
      } else {
        // Request encountered an error (status outside 200-299)
        toast.error(response?.generateChangePass?.message, 2500);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Card id="change-password" sx={{ boxShadow: "none !important" }}>
      <SoftBox pt={2} px={2} lineHeight={1}>
        <SoftTypography variant="h6" fontWeight="normal">
          Change Password
        </SoftTypography>
        <SoftTypography variant="button" fontWeight="regular" color="text">
          We will send you an email with the change password link
        </SoftTypography>
      </SoftBox>
      <SoftBox p={2} display="flex" justifyContent="flex-start">
        <SoftButton
          disabled={changePasswordClicked}
          variant="gradient"
          color="info"
          onClick={requestChangePass}
        >
          Request password change
        </SoftButton>
      </SoftBox>
    </Card>
  );
}

export default ChangePassword;
